const data = [
  {
    id: 1,
    name: "Car & Bike Sell",
    img: "https://i.ibb.co/L6fGBXk/seven.jpg",
    des: "This is a car and bike selling and buying website",
    tags: ["React", "Bootstrap", "etc"],
    link: "https://www.sevencarlounge.com/",
  },
  {
    id: 2,
    name: "Nft Social",
    img: "https://i.ibb.co/Gs9457s/nft.png",
    des: "This is a NFT website like instragram",
    tags: ["React", "MaterialUi", "etc"],
    link: "https://instaclone-001.netlify.app/",
    front: "https://github.com/RKD1180/instaclone",
  },

  {
    id: 3,
    name: "E-commerce",
    img: "https://i.ibb.co/dfkhZhX/nft.jpg",
    des: "This is a ecommerce website",
    tags: ["React", "Bootstrap", "etc"],
    link: "https://ilyn.global/",
  },
];

export default data;
